import React, { ReactElement, useEffect, useState } from 'react';
import { IconButton } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import { Map } from '!mapbox-gl';
import {
    StyledDivider,
    StyledZoomControlContainer,
} from './zoom-controls.styled';

import { useTheme } from '@material-ui/core/styles';
import { useSSRMediaQuery } from '@helpers';

export function ZoomControls({
    map,
    hasSelectedCountry,
    hideHeader,
}: {
    map: Map;
    hasSelectedCountry: boolean;
    hideHeader: boolean;
}): ReactElement {
    const theme = useTheme();
    const isSmallScreen = useSSRMediaQuery(theme.breakpoints.down('sm'));

    const [zoom, setZoom] = useState(map?.getZoom());
    const maxZoom = map?.getMaxZoom();
    const minZoom = map?.getMinZoom();

    useEffect(() => {
        if (!map) return;
        const onZoom = () => setZoom(map.getZoom());
        map.on('zoomend', onZoom);
        return () => {
            map.off('zoomend', onZoom);
        };
    }, [map]);

    // Skip rendering until session is hydrated to avoid incorrect layout flashes
    if (isSmallScreen === undefined) {
        return <></>;
    }

    return (
        <StyledZoomControlContainer
            $hasSelectedCountry={hasSelectedCountry}
            $isSmallScreen={isSmallScreen}
            $hideHeader={hideHeader}
        >
            <IconButton
                size="small"
                color="secondary"
                onClick={() => map.zoomIn()}
                disabled={!map || zoom >= maxZoom}
                aria-label="Zoom In"
            >
                <AddIcon fontSize="small" />
            </IconButton>
            <StyledDivider />
            <IconButton
                size="small"
                color="secondary"
                onClick={() => map.zoomOut()}
                disabled={!map || zoom <= minZoom}
                aria-label="Zoom Out"
            >
                <RemoveIcon fontSize="small" />
            </IconButton>
        </StyledZoomControlContainer>
    );
}
